module.exports = "<div class=\"tileInCart\" ng-class=\"[{'is-inTrolley' : $ctrl.product.IsInTrolley}, $ctrl.classModifier]\">\r\n    <p class=\"tileInCart-text\">in your cart</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/tile-in-cart.component.html
// module id = 384
// module chunks = 0